export const CHECKLIST_CONFIG = {
  columns: {
    crew: {
      title: "クルー",
      width: 60, // gridTemplateColumnsで使用する幅
    },
    supervisor: {
      title: "責任者",
      width: 60,
    },
    task: {
      title: "タスク",
    },
  },
};
